export const ROOT_ROUTE = 'delivery-note';
export const VIEW = 'view';
export const NEW = 'new';
export const EDIT = 'edit';
export const OVERVIEW = 'overview';
export const REMARKS = 'remarks';
export const LOG = 'log';



/** WEBPACK FOOTER **
 ** ./client/pages/delivery-note/constant.js
 **/